import { getErrorCode } from "../../../shared/helpers/getErrorMessage";

/** German sentences for what the three feedback routes can throw. */
export function feedbackErrorMessage(error: unknown): string {
  switch (getErrorCode(error)) {
    case "TECHNICIAN_ATTACHMENT_FORBIDDEN":
      return "Nur wer die Datei hochgeladen hat, kann sie entfernen.";
    case "TECHNICIAN_ATTACHMENT_NOT_FOUND":
      return "Die Datei wurde bereits entfernt.";
    case "APPOINTMENT_FORBIDDEN":
    case "TASK_FORBIDDEN":
      return "Nur der zugewiesene Handwerker kann hier etwas hinzufügen.";
    default:
      return "Speichern fehlgeschlagen. Bitte erneut versuchen.";
  }
}
